// extracted by mini-css-extract-plugin
export default {"layout":"AppLayout-module--layout--8df8c","modalVideo":"AppLayout-module--modal-video--33385","modalVideoInner":"AppLayout-module--modal-video-inner--3217f"};